import React, {Fragment} from 'react';
import SvgLogo from 'brand/logo.svg';
import SvgText from 'brand/logo-text.svg';
import css from './logo.module.scss';

export function Logo({ className }) {
  return (
    <span className={`${css.logo} ${className}`}>
      <SvgLogo />
    </span>
  );
}

Logo.Text = function Text({ className }) {
  return (
    <span className={`${css.text} ${className}`}>
      <SvgText />
    </span>
  );
}
